import React, { useContext } from 'react';
import { Pagination } from 'antd';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export interface ITablePaginationProps {
    current: number;
    pageSize: number;
    total: number;
    itemName?: string;
    pageSizeOptions?: string[];
    onChange: (page: number, pageSize: number) => void;
    align?: 'flex-end' | 'flex-start' | 'center' | 'space-between';
    style?: React.CSSProperties;
}

export default function TablePagination({
    current,
    pageSize,
    total,
    itemName = 'registros',
    pageSizeOptions = ['10', '50', '100'],
    onChange,
    align = 'flex-end',
    style,
}: ITablePaginationProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: align,
                padding: '0 4px',
                ...style,
            }}
        >
            <Pagination
                size="small"
                current={current}
                pageSize={pageSize}
                total={total}
                showTotal={(tot, range) => (
                    <span style={{ color: isDark ? '#8c8c8c' : '#64748b', fontSize: 13, marginRight: 8 }}>
                        Mostrando <strong>{range[0]}-{range[1]}</strong> de <strong>{poeValorComPontosEmMil(tot)}</strong> {itemName}
                    </span>
                )}
                showSizeChanger
                pageSizeOptions={pageSizeOptions}
                onChange={onChange}
            />
        </div>
    );
}
